module.exports = __webpack_public_path__ + "img/plot.dd6bbc67.png";